import React, { useState, useEffect } from 'react';
import dayjs from "../../../../util/dayjs-config";
import { Modal, Button, Form } from 'react-bootstrap';
import { FluentDatePicker } from '../../../../components/FluentUI/Fluent-DatePicker';
import { 
    UpdateProjectEndDate,
    UpdateProjectAndTasksEndDate,
} from '../../../../services/api/project-api';
import PropTypes from 'prop-types';
import { calendarIcon } from "../../../../assets/icons";
import "./project-end-date-update-modal.scss";

const EndDateUpdateModal = ({
    projectId,
    dateFormatID,
    originalProjectEndDate,
    selectedProjectEndDate,
    isEndDateModalOpen,
    setIsEndDateModalOpen,
    setShowEditedModal,
    setErrorModal,
}) => {
    const [extendTaskEndDate, setExtendTaskEndDate] = useState(false);
    const [selectedTaskEndDate, setSelectedTaskEndDate] = useState(new Date());
    const [invalidTaskEndDate, setInvalidTaskEndDate] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setSelectedTaskEndDate(originalProjectEndDate);
        setExtendTaskEndDate(false);
    }, []);

    useEffect(() => {
        setSelectedTaskEndDate(selectedProjectEndDate);
    }, [selectedProjectEndDate]);

    useEffect(() => {
        if ((selectedTaskEndDate > selectedProjectEndDate) && extendTaskEndDate) {
            setInvalidTaskEndDate(true);
        } else {
            setInvalidTaskEndDate(false);
        }
    }, [selectedTaskEndDate]);

    useEffect(() => {
        if ((selectedTaskEndDate > selectedProjectEndDate) && extendTaskEndDate) {
            setInvalidTaskEndDate(true);
        } else if (!extendTaskEndDate) {
            setInvalidTaskEndDate(false);
        } else {
            setInvalidTaskEndDate(false);
        }
    }, [extendTaskEndDate]);

    useEffect(() => {
        if (!isEndDateModalOpen) {
            setSelectedTaskEndDate(selectedProjectEndDate);
        }
    }, [isEndDateModalOpen])

    const onProjectEndDateCancel = () => {
        setExtendTaskEndDate(false);
        setSelectedTaskEndDate(selectedProjectEndDate);
        setIsEndDateModalOpen(false);
    }

    const onProjectEndDateError = (error) => {
        setSelectedTaskEndDate(selectedProjectEndDate);
        setErrorModal(error);
        setIsEndDateModalOpen(false);
        setSaving(false);
    }

    const onProjectEndDateSave = async () => {
        try {
            setSaving(true);
            let data = {};
            let output = {};            
            if (extendTaskEndDate) {
                data = {
                    Id: projectId,
                    End: dayjs(selectedProjectEndDate).endOf('day').format("YYYY-MM-DDTHH:mm:ss"),
                    TasksEnd: dayjs(selectedTaskEndDate).endOf('day').format("YYYY-MM-DDTHH:mm:ss")
                }
                output = await UpdateProjectAndTasksEndDate(data);
            } else {
                data = {
                    Id: projectId,
                    End: dayjs(selectedProjectEndDate).endOf('day').format("YYYY-MM-DDTHH:mm:ss")
                }
                output = await UpdateProjectEndDate(data);
            }
            
            if (output?.status === 200) {
                if(output?.data === true){
                    setShowEditedModal(true);
                    setSaving(false);                   
                } else {
                    onProjectEndDateError("Failed to update Project Due Date");
                }
            } else {
                onProjectEndDateError(output?.response?.data);
            }
        } catch (error) {
            onProjectEndDateError(error);
        }
    }

    return (
        <Modal 
            className="project-end-date-modal"
            show={isEndDateModalOpen}
            onHide={() => setIsEndDateModalOpen(false)}
        >
            <Modal.Header>
                <Modal.Title>
                    Update Project End Date and Tasks Due Date
                </Modal.Title>
                <Button
                    className="close-document-viewer-btn btn-primary"
                    onClick={() => setIsEndDateModalOpen(false)}
                />
            </Modal.Header>
            <Modal.Body className="action-popup">
                <div>
                    <p className="description">
                        Would you like to extend the end date for all the active tasks in this Project?
                    </p>
                    <Form.Row>
                        <div className="mt-3 mb-1">
                            <Form.Group>
                                <FluentDatePicker
                                    id="taskEndDate"
                                    name="taskEndDate"
                                    autoComplete="off"
                                    placeholder="Click to select a new task due date"
                                    value={selectedTaskEndDate}
                                    onChange={(value) => setSelectedTaskEndDate(value)}
                                    maxDate={selectedProjectEndDate}
                                    dateFormatID={dateFormatID}
                                    isInvalid={invalidTaskEndDate}
                                    feedback={invalidTaskEndDate ? "Please select a date on or before the project end date" : null}
                                    disabled={!extendTaskEndDate}
                                />
                                {   !invalidTaskEndDate &&
                                    <img className="calendar-icon" src={calendarIcon} alt="Calendar Icon" />
                                }
                            </Form.Group>
                            <Form.Group>
                                <Form.Check
                                    id="enableTaskEndDate"
                                    name="enableTaskEndDate"
                                    type="checkbox"
                                    checked={extendTaskEndDate}
                                    onChange={(e) => { setExtendTaskEndDate(e.target.checked) }}
                                    className="task-end-date-checkbox"
                                />
                                <Form.Label htmlFor="enableTaskEndDate" className="task-end-date-checkbox">
                                    Update Task Due Date
                                </Form.Label>
                            </Form.Group>
                        </div>
                    </Form.Row>
                    <div className="action-buttons">
                        <Button className="btn-outlined" onClick={onProjectEndDateCancel}>Cancel</Button>
                        <Button disabled={saving || (invalidTaskEndDate)} onClick={onProjectEndDateSave}>Save</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

EndDateUpdateModal.propTypes = {
    projectId: PropTypes.number.isRequired,
    dateFormatID: PropTypes.string.isRequired,
    originalProjectEndDate: PropTypes.string,    
    selectedProjectEndDate: PropTypes.string,
    isEndDateModalOpen: PropTypes.bool.isRequired,
    setIsEndDateModalOpen: PropTypes.func,
    setShowEditedModal: PropTypes.func,
    setErrorModal: PropTypes.func,
};

export default EndDateUpdateModal;
